import { t } from 'i18next';
import * as yup from 'yup';

import { numberSchemaWithTransform } from 'core/yup';

export const addVariationSchema = () =>
  yup.object().shape({
    variations: yup
      .array()
      .of(
        yup.object().shape({
          id: yup.string(),
          length: numberSchemaWithTransform()
            .nullable()
            .required(t('errorVariationBothLengthAndQuantityRequired')),
          quantity: numberSchemaWithTransform()
            .nullable()
            .required(t('errorVariationBothLengthAndQuantityRequired')),
        })
      )
      .label(t('labelVariations'))
      .min(1, t('errorVariationRequiredAtLeastOne'))
      .required('Variations are required'),
  });
